/* Recipe Box presentation for specialty collections.
   Recipe data, attribution, exports and cooking checklists remain in the core UI. */
(() => {
  const el=(tag,cls,text)=>{const n=document.createElement(tag);n.className=cls;if(text!==undefined)n.textContent=String(text);return n;};
  const safeURL=value=>{try{const u=new URL(value);return u.protocol==='https:'?u.href:null;}catch{return null;}};
  function photoFor(id) {
    const p=window.NanaRecipePhotoRegistry?.[id];
    if(!p?.approved || !p.alt || !['photograph','illustration'].includes(p.kind)) return null;
    const url=safeURL(p.url);return url ? {...p,url} : null;
  }
  function photoFigure(p,compact=false) {
    const figure=el('figure',compact?'nse-card-photo':'nse-recipe-photo'),img=el('img','');
    img.src=compact&&p.thumbnailUrl?(safeURL(p.thumbnailUrl)||p.url):p.url;img.alt=compact?'':p.alt;img.loading='lazy';img.decoding='async';img.width=p.width||1200;img.height=p.height||800;
    if(p.objectPosition)img.style.objectPosition=p.objectPosition;
    figure.append(img);return figure;
  }
  function decorateRecipe(section,record) {
    const detail=section.querySelector('[data-specialty-detail]');
    if(!detail || detail.dataset.nseRecipe===record.id) return;
    detail.dataset.nseRecipe=record.id;detail.classList.add('nse-detail','rb-recipe-detail');
    const labels=JSON.parse(section.querySelector('[data-specialty-labels]').textContent);
    const steps=detail.querySelector('.nana-specialty__steps'),firstList=detail.querySelector('.nana-specialty__ingredients');
    if(!steps||!firstList)return;
    const ingredientHeading=[...detail.children].find(n=>n.tagName==='H3'&&n.textContent===labels.ingredients);
    const methodHeading=steps.previousElementSibling;
    if(ingredientHeading&&methodHeading?.tagName==='H3') {
      const body=el('div','nse-recipe-body'),pantry=el('section','nse-ingredients'),method=el('section','nse-method');
      detail.insertBefore(body,ingredientHeading);
      let n=ingredientHeading;
      while(n&&n!==methodHeading){const next=n.nextElementSibling;pantry.append(n);n=next;}
      method.append(methodHeading,steps);body.append(pantry,method);
    }
    const swaps=[...detail.querySelectorAll('.nana-specialty__swap')];
    if(swaps.length) {
      const guide=el('section','nse-adaptations');
      const first=swaps[0],heading=first.previousElementSibling;
      if(heading?.tagName==='H3')guide.append(heading);
      swaps.forEach(swap=>{
        const scope=swap.nextElementSibling?.classList.contains('nana-specialty__scope')?swap.nextElementSibling:null;
        const cells=[...swap.children];
        if(cells.length===3){const arrow=el('span','nse-swap-arrow','→');arrow.setAttribute('aria-hidden','true');cells[0].after(arrow);}
        guide.append(swap);if(scope)guide.append(scope);
      });
      detail.querySelector('.nse-recipe-body')?.before(guide);
    }
    // Notes may be collapsed; the separately rendered safety section stays visible.
    const noteHeading=[...detail.children].find(n=>n.tagName==='H3'&&n.textContent===labels.notes);
    const sourceHeading=[...detail.children].find(n=>n.tagName==='H3'&&n.textContent===labels.source);
    if(noteHeading&&sourceHeading){
      const fold=el('details','nse-notes');fold.append(el('summary','',labels.notes));detail.insertBefore(fold,noteHeading);
      let n=noteHeading.nextElementSibling;noteHeading.remove();
      while(n&&n!==sourceHeading){const next=n.nextElementSibling;fold.append(n);n=next;}
    }
    const p=photoFor(record.id);if(p){const title=detail.querySelector('h2');title?.after(photoFigure(p));}
  }
  function decorateCards(section,records) {
    const map=new Map(records.map(record=>[String(record.id),record]));
    section.querySelectorAll('[data-nana-recipe-id]').forEach(card=>{
      const record=map.get(card.dataset.nanaRecipeId);
      if(!record)return;
      card.dataset.rbCard='';
      card.dataset.rbId=String(record.id);
      card.dataset.rbText=[record.title,record.country,record.restaurant,record.region,
        ...(record.ingredientGroups||[]).flatMap(group=>[group.name,...(group.items||[])])
      ].filter(Boolean).join(' ').normalize('NFKC').toLocaleLowerCase();
      card.classList.add('rb-card');
      card.querySelector('h3')?.classList.add('rb-card-title');
      if(card.dataset.nseCard)return;
      card.dataset.nseCard='true';
      const photo=photoFor(record.id);
      if(photo){
        const figure=photoFigure(photo,true);figure.classList.add('rb-card-image');card.prepend(figure);
      } else {
        const placeholder=el('div','rb-card-image rb-card-image--placeholder');
        placeholder.setAttribute('aria-hidden','true');
        card.prepend(placeholder);
      }
    });
    section.dispatchEvent(new CustomEvent('nana:recipebox-ready',{bubbles:true}));
  }
  document.addEventListener('nana:specialty-recipe-open',event=>{
    const section=event.target.closest('[data-nana-specialty]');if(section&&event.detail?.record)decorateRecipe(section,event.detail.record);
  });
  document.addEventListener('nana:specialty-cards-ready',event=>{
    const section=event.target.closest('[data-nana-specialty]');if(section&&Array.isArray(event.detail?.records))decorateCards(section,event.detail.records);
  });
  window.NanaSpecialtyEditorial={decorateRecipe,decorateCards};
})();


